import { createSlice } from "@reduxjs/toolkit"

// Функция для получения ID пользователя
const getUserId = () => {
  try {
    const userData = localStorage.getItem("user")
    if (userData) {
      const user = JSON.parse(userData)
      return user?.id || "default"
    }
  } catch (error) {
    console.error("Error parsing user data:", error)
  }
  return "default"
}

// Функция для получения сохраненного интервала для конкретного пользователя
const getTimeslotStepsFromStorage = () => {
  try {
    const userId = getUserId()
    const storageKey = `timeslotSteps_${userId}`
    const savedSteps = localStorage.getItem(storageKey)
    return savedSteps ? parseInt(savedSteps, 10) : 30
  } catch (error) {
    console.error("Error reading timeslot steps:", error)
    return 30
  }
}

const initialState = {
  timeslotSteps: getTimeslotStepsFromStorage(),
}

export const bookingsCalendarSlice = createSlice({
  name: "bookingsCalendar",
  initialState,
  reducers: {
    editTimeslotSteps: (state, { payload }) => {
      state.timeslotSteps = payload
      // Сохраняем в localStorage для конкретного пользователя
      try {
        const userId = getUserId()
        const storageKey = `timeslotSteps_${userId}`
        localStorage.setItem(storageKey, payload.toString())
      } catch (error) {
        console.error("Error saving timeslot steps:", error)
      }
    },
  },
})

export const { editTimeslotSteps } = bookingsCalendarSlice.actions

export default bookingsCalendarSlice.reducer